import { m } from '@sohanscript/i18n';
import { useParams } from '@tanstack/react-router';
import type { ComponentProps } from 'react';
import { PageBreadcrumb } from '@/components/page-breadcrumb';
import { localizeServices } from '@/lib/data/services-i18n';

type ServiceBreadcrumbProps = ComponentProps<'div'>;

export function ServiceBreadcrumb({ ...props }: ServiceBreadcrumbProps) {
	const { slug } = useParams({ from: '/_main/build/$slug' });

	const items: { slug: string; title: string }[] = localizeServices().map(
		(service) => ({
			slug: service.slug,
			title: service.title,
		}),
	);

	return (
		<PageBreadcrumb
			currentSlug={slug}
			currentTitle={items.find((s) => s.slug === slug)?.title}
			listTo="/services"
			listLabel={m.nav_services()}
			itemTo="/build/$slug"
			items={items}
			{...props}
		/>
	);
}
